import styled from 'styled-components';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const DrawerSeparator = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  width: 100%;
  margin-bottom: ${rem(14)};
`;
